import Alpine from "alpinejs";

Alpine.data("modelsPresets", () => {
    const defaultData = {
        presets: [],
        currentIndex: 0,
        currentPreset: {},
        models: "",
        link: "",
        async init() {
            this.currentPreset = this.presets[this.currentIndex];
            const res = await window.axios.get(
                `/filters/${this.currentPreset.slug}/partial`
            );
            this.models = res.data;
            this.link = `/filters/${this.currentPreset.slug}/`;
        },
        async setPreset(idx) {
            this.currentPreset = this.presets[idx];
            const res = await window.axios.get(
                `/filters/${this.currentPreset.slug}/partial`
            );
            this.models = res.data;
            this.link = `/filters/${this.currentPreset.slug}/`;
            this.currentIndex = idx;
        },
        nextPreset() {
            if (this.currentIndex < this.presets.length - 1) {
                const idx = this.currentIndex + 1;
                this.setPreset(idx);
            }
        },
        prevPreset() {
            if (this.currentIndex > 0) {
                const idx = this.currentIndex - 1;
                this.setPreset(idx);
            }
        },
    };

    return {
        ...defaultData,
        presets: window.presets,
    };
});
